import client from '../../base-api';

const moduleURL = '/course-private-learning-coaching-module';

const coursePrivateLearningCoachingModuleService = {
    getModules(filterData: any) {
        return client.get(`${moduleURL}`, {params: filterData});
    },

    getModule(moduleId: number) {
        return client.get(`${moduleURL}/${moduleId}`);
    },

    postModule(moduleData: any) {
        return client.post(`${moduleURL}`, moduleData);
    },

    putModule(moduleData: any, moduleId: number) {
        return client.put(`${moduleURL}/${moduleId}`, moduleData);
    },

    deleteModule(moduleData: number) {
        return client.delete(`${moduleURL}/delete/${moduleData}`);
    },
}

export default coursePrivateLearningCoachingModuleService;